import classNames from 'classnames'
import React from 'react'

import { useNavigate } from '@lib/react-router-dom'

import { Title1 } from '@ui/Typography'
import { IconButton } from '@ui/components/Button'
import { Link } from '@ui/components/Link'
import { TextColorType } from '@ui/design-system/colors/colors'
import { ArrowIcon } from '@ui/icons/Arrow.icon'

import { Box } from '@shared/components/Box'

import styles from './BackButton.module.scss'

export interface BackButtonProps {
  section?: string
  backUrl?: string
  backLabel?: string
  fillColor?: TextColorType
  onClick?: () => void
  className?: string
}

export const BackButton: React.FC<BackButtonProps> = (props) => {
  const { section, className, backUrl, onClick, fillColor } = props

  const navigate = useNavigate()

  return (
    <nav className={classNames(styles.wrapper, className)}>
      {backUrl && (
        <Link to={backUrl}>
          <button data-test='back-button' type='button' className='button'>
            <ArrowIcon.Left size={16} color={fillColor} />
          </button>
        </Link>
      )}
      {!backUrl && (
        <Box pr='x4'>
          <IconButton.Ghost
            icon={ArrowIcon.Left}
            onClick={() => {
              onClick ? onClick() : navigate(-1)
            }}
            data-test='back-button'
          />
        </Box>
      )}
      <Title1 className={styles.backLabel} medium>
        {section}
      </Title1>
    </nav>
  )
}
